module.exports = __webpack_public_path__ + "static/img/mky.866ed992.png";